import React from "react";

export default function AccordionSummary({
  accordionItem,
  expandAccordion,
  setExpandAccordion,
  icons,
  summaryContent,
  children,
  storeAccordionStatus,
  expandOnIconClickOnly,
}) {
  const bgSummaryColor = accordionItem?.bgSummaryColor || "bg-white";
  const SummaryContentVariant = summaryContent;

  const handleAccordionExpansion = () => {
    setExpandAccordion(!expandAccordion);
    storeAccordionStatus();
  };

  const defaultClassNames = !expandAccordion
    ? bgSummaryColor + " w-full shadow-md mb-4 p-4 rounded"
    : "bg-white" + " w-full shadow-md mb-4 p-4 rounded";

  return (
    <div className={accordionItem?.summaryClasses ?? defaultClassNames}>
      <div
        className={`w-full flex flex-row justify-between items-center ${
          expandOnIconClickOnly ? "" : "hover:cursor-pointer"
        }`}
        {...(!expandOnIconClickOnly && {
          onClick: handleAccordionExpansion,
        })}
      >
        <SummaryContentVariant accordionItem={accordionItem} />
        <div
          onClick={(e) => {
            if (expandOnIconClickOnly) {
              e.stopPropagation();
              handleAccordionExpansion();
            }
          }}
          className={expandOnIconClickOnly ? "cursor-pointer" : ""}
        >
          {expandAccordion ? icons?.shrinkIcon : icons?.expandIcon}
        </div>
      </div>

      {expandAccordion && accordionItem
        ? React.cloneElement(children, { accordionItem })
        : ""}
    </div>
  );
}
